import { Box } from '@mui/material'
import React from 'react'
import { appColors } from 'utils'
import backGroundImage from 'assets/landingPageBackground.png'
import innovaLogo from 'assets/innovaLogo.png'
import innovaLogoBlack from 'assets/innovaLogoBlack.png'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'

const LoginCallBack = () => {
  const { theme, getLinearGradient } = useInnovaTheme()

  const getInnovaLogo = () => {
    return theme === 'dark' ? innovaLogo : innovaLogoBlack
  }

  return (
    <Box
      sx={{
        backgroundImage: `url(${backGroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100%',
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
      }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '130px' }}>
        <Box
          sx={{
            background: getLinearGradient(),
            width: '400px',
            height: '500px',
            borderRadius: '20px',
            border: `1px solid`,
            borderColor: appColors.itemBackColor,
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Box
            component='img'
            sx={{
              height: '250px',
              width: '306px',
            }}
            alt='innova logo'
            src={getInnovaLogo()}
          />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              width: '90%',
            }}>
            <Box
              sx={{
                color: theme === 'dark' ? '#FFF' : appColors.textColor,
                fontSize: '20px',
                fontWeight: 600,
                textAlign: 'center',
                marginTop: '20px',
              }}>
              You have successfully logged in!
            </Box>
            <Box
              sx={{
                color: theme === 'dark' ? '#FFF' : appColors.textColor,
                fontSize: '16px',
                textAlign: 'center',
                marginTop: '10px',
              }}>
              You can now close this window and return to the application.
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default LoginCallBack
